<template>
    <div class="People">
        <div class="row record-section-row">
            <div class="col">
                <h4>Child Placements:</h4>
                <div>
                    <MultiMembershipEditor :fields="[{name: 'ClientSubProgramMembership.Client.Person.FullName', title: 'NAME'},
                                           {name: 'StartDate', title: 'PLACEMENT', callback: 'formatDate|MM/DD/YY'},
                                           {name: 'EndDate', title: 'END', callback: 'formatDate|MM/DD/YY|N/A'},
                                           {name: 'ClientSubProgramMembership.ProgramServices', title: 'Level',callback: this.GetProgramService}]"
                                           :field-data="FamilyRecordData.Family.Placements"
                                           :edit-mode="false"
                                           select-label="Resource Family:"
                                           options-type="API"
                                           options-method="Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/GetAvailablePlacements"
                                           :options-method-record-id="FamilyRecordData"
                                           add-record-method="Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/AssignFirstPlacement"
                                           add-record-record-property-name="FosterResourceFamilyID"
                                           :add-record-additional-payload="{ClientSubProgramMembershipID: FamilyRecordData}"
                                           add-record-modal-title="Add First Placement"
                                           transfer-record-method="Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/TransferPlacement"
                                           transfer-record-record-property-name="FosterResourceFamilyID"
                                           :transfer-record-additional-payload="{ClientSubProgramMembershipID: FamilyRecordData}"
                                           transfer-record-modal-title="Transfer Placement"
                                           transfer-record-effective-date-property-name="StartDate"
                                           delete-record-method="Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/DeleteCurrentPlacement"
                                           :delete-record-additional-payload="{ClientSubProgramMembershipID: FamilyRecordData}"
                                           delete-record-modal-title="Delete Current Placement"
                                           delete-record-modal-text="NOTICE: You are about to delete this child's current placement.  If there was a previous placement, it will re-open that placement." />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Home Study Writers:</h4>
                <div>
                    <SingleMembershipEditor :fields="[{name: 'Employee.Person.FullName', title: 'NAME'}, {name: 'StartDate', title: 'STARTED', callback: 'formatDate|MM/DD/YY'}, {name: 'EndDate', title: 'ENDED', callback: 'formatDate|MM/DD/YY|N/A'}]"
                                            :field-data="FamilyRecordData.ASWs"
                                            :edit-mode="EditMode"
                                            select-label="Home Study Writer:"
                                            options-type="API"
                                            options-method="Core/EmployeeCaseload/GetAvailableFosterResourceFamilyASWs"
                                            :options-method-record-id="FamilyRecordData.Family.Id"
                                            add-record-method="Core/EmployeeCaseload/AddFirstASWFamilyMembership"
                                            add-record-record-property-name="EmployeeID"
                                            :add-record-additional-payload="{FosterResourceFamilyID: FamilyRecordData.Family.Id, EmployeeRole: 'Adoption Social Worker'}"
                                            add-record-modal-title="Add Initial Home Study Writer"
                                            transfer-record-method="Core/EmployeeCaseload/TransferASWFamilyMembership"
                                            transfer-record-record-property-name="EmployeeID"
                                            :transfer-record-additional-payload="{FosterResourceFamilyID: FamilyRecordData.Family.Id, EmployeeRole: 'Adoption Social Worker'}"
                                            transfer-record-modal-title="Transfer Home Study Writer"
                                            transfer-record-effective-date-property-name="StartDate"
                                            delete-record-method="Core/EmployeeCaseload/DeleteCurrentASWFamilyMembership"
                                            :delete-record-additional-payload="{Id: FamilyRecordData.Family.Id}"
                                            delete-record-modal-title="Delete Current Home Study Writer"
                                            delete-record-modal-text="NOTICE: You are about to delete this family's current Home Study Writer.  If there was a previous Home Study Writer assigned, the family will be re-assigned to them." />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Resource Family Specialists / Licensors:</h4>
                <div>
                    <SingleMembershipEditor :fields="[{name: 'Employee.Person.FullName', title: 'NAME'}, {name: 'StartDate', title: 'STARTED', callback: 'formatDate|MM/DD/YY'}, {name: 'EndDate', title: 'ENDED', callback: 'formatDate|MM/DD/YY|N/A'}]"
                                            :field-data="FamilyRecordData.RFSs"
                                            :edit-mode="EditMode"
                                            select-label="Resource Family Specialist:"
                                            options-type="API"
                                            options-method="Core/EmployeeCaseload/GetAvailableFosterResourceFamilyRFSs"
                                            :options-method-record-id="FamilyRecordData.Family.Id"
                                            add-record-method="Core/EmployeeCaseload/AddFirstRFSFamilyMembership"
                                            add-record-record-property-name="EmployeeID"
                                            :add-record-additional-payload="{FosterResourceFamilyID: FamilyRecordData.Family.Id, EmployeeRole: 'Resource Family Specialist'}"
                                            add-record-modal-title="Add Initial Resource Family Specialist"
                                            transfer-record-method="Core/EmployeeCaseload/TransferRFSFamilyMembership"
                                            transfer-record-record-property-name="EmployeeID"
                                            :transfer-record-additional-payload="{FosterResourceFamilyID: FamilyRecordData.Family.Id, EmployeeRole: 'Resource Family Specialist'}"
                                            transfer-record-modal-title="Transfer Resource Family Specialist"
                                            transfer-record-effective-date-property-name="StartDate"
                                            delete-record-method="Core/EmployeeCaseload/DeleteCurrentRFSFamilyMembership"
                                            :delete-record-additional-payload="{Id: FamilyRecordData.Family.Id}"
                                            delete-record-modal-title="Delete Current Resource Family Specialist"
                                            delete-record-modal-text="NOTICE: You are about to delete this family's current Resource Family Specialist.  If there was a previous RFS assigned, the family will be re-assigned to them." />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Family Members:</h4>
                <div>
                    <ContactDisplayAndEdit :edit-mode="EditMode"
                                           :global-update="false"
                                           get-endpoint="Foster/ResourceFamily/Contacts/FamilyMembers/GetContacts"
                                           :get-payload="{Id: FamilyRecordData.Family.Id}"
                                           add-edit-endpoint="Foster/ResourceFamily/Contacts/FamilyMembers/AddEditContact"
                                           :add-edit-payload="{ChartID: FamilyRecordData.Family.Id}"
                                           delete-endpoint="Foster/ResourceFamily/Contacts/FamilyMembers/DeleteContact"
                                           :require-dob="true"
                                           contact-category="Family Member"
                                           :relationship-options="FamilyRelationOptions"
                                           relationship-label="Foster Parents"
                                           :display-age="true"
                                           :include-pnw-family-tracking="IsPNW"
                                           :display-relationship="true" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Babysitters:</h4>
                <div>
                    <ContactDisplayAndEdit :edit-mode="EditMode"
                                           :global-update="false"
                                           get-endpoint="Foster/ResourceFamily/Contacts/Babysitters/GetContacts"
                                           :get-payload="{Id: FamilyRecordData.Family.Id}"
                                           add-edit-endpoint="Foster/ResourceFamily/Contacts/Babysitters/AddEditContact"
                                           :add-edit-payload="{ChartID: FamilyRecordData.Family.Id}"
                                           delete-endpoint="Foster/ResourceFamily/Contacts/Babysitters/DeleteContact"
                                           :require-dob="false"
                                           contact-category="Babysitter"
                                           relationship-options="Babysitter"
                                           relationship-label="Foster Family"
                                           :display-age="false"
                                           :display-relationship="false"
                                           :include-charting="true"
                                           :include-pnw-babysitter-tracking="IsPNW"
                                           :sub-program-id="FamilyRecordData.FamilyProgramMembership.SubProgramID" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Pets:</h4>
                <div>
                    <FamilyDogDisplayAndEdit :edit-mode="EditMode"
                                             :global-update="false"
                                             get-endpoint="Foster/ResourceFamily/Contacts/Dogs/GetDogs"
                                             :get-payload="{Id: FamilyRecordData.Family.Id}"
                                             add-edit-endpoint="Foster/ResourceFamily/Contacts/Dogs/AddEditDog"
                                             :add-edit-payload="{FosterResourceFamilyID: FamilyRecordData.Family.Id}"
                                             delete-endpoint="Foster/ResourceFamily/Contacts/Dogs/DeleteDog"
                                             :family-record-data="FamilyRecordData" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Misc. Contacts:</h4>
                <div>
                    <ContactDisplayAndEdit :edit-mode="EditMode"
                                           :global-update="false"
                                           get-endpoint="Foster/ResourceFamily/Contacts/Misc/GetContacts"
                                           :get-payload="{Id: FamilyRecordData.Family.Id}"
                                           add-edit-endpoint="Foster/ResourceFamily/Contacts/Misc/AddEditContact"
                                           :add-edit-payload="{ChartID: FamilyRecordData.Family.Id}"
                                           delete-endpoint="Foster/ResourceFamily/Contacts/Misc/DeleteContact"
                                           :require-dob="false"
                                           contact-category="Misc"
                                           :relationship-options="null"
                                           relationship-label="Foster Family"
                                           :display-age="false"
                                           :display-relationship="true"
                                           :agency-input="true"
                                           :display-agency="true" />
                </div>
            </div>
        </div>
        <div class="row record-section-row" v-if="CheckPermission('Foster.CareCommunity')">
            <div class="col">
                <h4>Family Care Community:</h4>
                <div>
                    <CareCommunityEditor :fields="[{name: '__slot:EditRecord', title: 'CARE COMMUNITY'}, {name: 'CareCommunity.TeamLeaderName', title: 'TEAM LEADER'}, {name: 'CareCommunity.Region', title: 'REGION'}, {name: 'StartDate', title: 'STARTED', callback: 'formatDate|MM/DD/YY'}, {name: 'EndDate', title: 'ENDED', callback: 'formatDate|MM/DD/YY|N/A'}]"
                                         :field-data="FamilyRecordData.CommunityCareMemberships"
                                         :edit-mode="EditMode"
                                         select-label="New Care Community:"
                                         options-type="API"
                                         options-method="Foster/CareCommunity/CareCommunityListOptions"
                                         :options-method-record-id="FamilyRecordData.Family.Id"
                                         add-record-method="Foster/CareCommunity/AddFamilyToCareCommunity"
                                         add-record-record-property-name="CareCommunityID"
                                         :add-record-additional-payload="{FamilyID: FamilyRecordData.Family.Id}"
                                         :add-record-date="true"
                                         end-record-method="Foster/CareCommunity/EndFamilyToCareCommunity"
                                         :end-record-id="FamilyRecordData.Family.Id"
                                         update-record-method="Foster/CareCommunity/UpdateFamilyToCareCommunity"
                                         :update-record-id="FamilyRecordData.Id"
                                         add-record-modal-title="Add Care Community"
                                         get-endpoint="Foster/CareCommunity/GetCareCommunitiesForFamily"
                                         :get-payload="{Id: FamilyRecordData.Family.Id}"
                                         transfer-record-modal-title="Transfer Care Community"
                                         transfer-record-effective-date-property-name="StartDate"
                                         delete-record-method="Foster/CareCommunity/DeleteCurrentFamilyToCareCommunity"
                                         delete-record-modal-title="Delete Current Care Community"
                                         delete-record-modal-text="NOTICE: You are about to delete this family's current Care Community.  If there was a previous Care Community assigned, the family will be re-assigned to them." />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Respite Hostings Provided:</h4>
                <div>
                    <RespiteEditor :host-resource-family-id="FamilyRecordData.Id"  :can-edit="false" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Respites Used:</h4>
                <div>
                    <RespiteEditor :using-resource-family-id="FamilyRecordData.Id"  :can-edit="false" />
                </div>
            </div>
        </div>
        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" />
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import SingleMembershipEditor from '../../../Core/ItemEditors/SingleMembershipEditor';
    import MultiMembershipEditor from '../../../Core/ItemEditors/MultiMembershipEditor';
    import CareCommunityEditor from '../../../Core/ItemEditors/CareCommunityEditor';
    import ContactDisplayAndEdit from '../../../Core/ItemEditors/ContactDisplayAndEdit.vue';
    import FamilyDogDisplayAndEdit from './FamilyDogDisplayAndEdit.vue';
    import RespiteEditor from '../../Children/ChildRecord/RespiteEditor.vue';
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';


    export default {
        props: [
            'FamilyRecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            },
            GetProgramService(value) {
                if (value.length > 0) {
                    return value[0].ProgramService.Name;
                }
                else return "";
                
            }
        },
        components: {
            SingleMembershipEditor,
            MultiMembershipEditor,
            ContactDisplayAndEdit,
            FamilyDogDisplayAndEdit,
            CareCommunityEditor,
            RespiteEditor,
            EditMode
        },
        mounted() {

        },
        computed: {
            FamilyRelationOptions: function () {
                return this.$store.state.Options.FamilyRelations;
            },
            IsPNW: function () {
                if (this.$store.state.Options.PNWSubPrograms.includes(this.FamilyRecordData.FamilyProgramMembership.SubProgramID.toUpperCase())) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }
</script>

<style scoped>

</style>